/*
 * Per-rule copy for the Task Generation card. Pure and tested because
 * index.jsx has no test harness.
 */

import moment from 'moment-timezone';

// For the no-join rules the server computes dueAt = session start + delay, so
// the value is not a wait after a trigger.
const SESSION_START_DELAY_TYPES: ReadonlyArray<string | null | undefined> = [
  'PRE_SESSION_NO_JOIN',
  'REMINDER_LINK_NO_JOIN'
];

export const delay_label = (taskType: string | null | undefined): string => {
  if (SESSION_START_DELAY_TYPES.includes(taskType)) return 'Minutes after session start';
  if (taskType === 'REMINDER_REPLY') return 'Reply window (minutes)';
  return 'Delay (minutes)';
};

export const delay_title = (taskType: string | null | undefined): string => {
  if (SESSION_START_DELAY_TYPES.includes(taskType)) {
    return 'How many minutes after the session starts to check whether the member joined. Blank = the server default.';
  }
  if (taskType === 'REMINDER_REPLY') {
    return 'How long to wait for a reply to the reminder before creating the task. Blank = the server default.';
  }
  return 'How long to wait after the trigger before re-checking whether the member got through on their own. Blank = the server default.';
};

// Mirrors goserver ruleBlankExpiryDefault: a blank lead expiry enforces 12 h.
const BLANK_EXPIRY_DEFAULT_TYPES: ReadonlyArray<string | null | undefined> = [
  'LEAD_OTP_NOT_VERIFIED'
];
const LEAD_BLANK_EXPIRY_MINUTES = 720;

// 0 = a blank box means no expiry.
export const blank_expiry_default_minutes = (taskType: string | null | undefined): number =>
  BLANK_EXPIRY_DEFAULT_TYPES.includes(taskType) ? LEAD_BLANK_EXPIRY_MINUTES : 0;

export const expiry_placeholder = (taskType: string | null | undefined): string => {
  const d = blank_expiry_default_minutes(taskType);
  return d > 0 ? String(d) : '';
};

export const expiry_title = (taskType: string | null | undefined): string => {
  const base = 'An instant task nobody touches within this many minutes is auto-completed.';
  if (BLANK_EXPIRY_DEFAULT_TYPES.includes(taskType)) return `${base} blank = 12 h default.`;
  return `${base} Leave blank for no expiry.`;
};

// '' when the server sent no enabled_at or an unparseable one.
export const enabled_since_label = (enabledAt: unknown): string => {
  if (!enabledAt || typeof enabledAt !== 'string') return '';
  const m = moment(enabledAt, moment.ISO_8601, true);
  if (!m.isValid()) return '';
  return `Enabled since ${m.tz('Asia/Kolkata').format('D MMM YYYY')}`;
};
